import { constants, typographyStyles } from "@newsela/angelou";

const { textXSObj: text4 } = typographyStyles;
const { colors } = constants;

export const footnoteCss = {
  textAlign: "center",
  ...text4,

  "> *": {
    display: "inline",
  },
};

export const linkCss = {
  color: colors.ui.neutral[700],
  paddingLeft: "5px",
  margin: "0",
  fontWeight: "bold",
  ...text4,
};
